import React from 'react';
import {Link} from 'react-router-dom';
import {DateTime} from 'luxon';

import Authenticated from 'Components/Layouts/Authenticated';
import {PrimaryButton} from 'Components/Button';
import MailLink from 'Components/Utilities/MailLink';
import {Stream} from 'Components/MainStage';

export default class TestStream extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        return (
            <Authenticated>
                <h1 className="mb-2 text-2xl font-bold">
                    Test Stream
                </h1>

                <div className="w-full md:w-3/4 mx-auto text-center my-12">
                    <p>
                        If you can see and hear this team stream you should have no problems viewing the live show. 
                        If the stream is buffering this will be due to your internet.
                    </p>

                    <p className="mt-4">
                        Once you've watched the test stream and are happy it's all working, 
                        click the home icon at the top of the page to explore the rest of the event!
                    </p>

                    <p className="mt-4">
                        If you can't hear anything at first don't be alarmed! 
                        Please hover / click on the video to display the play bar and use 
                        the volume controls to increase the sound. 
                        Some browsers automatically mute at first.
                        If you're still having problems, contact{" "}
                        <MailLink/>
                    </p>

                    <div className="mt-12">
                        <Stream
                            stream={{
                                prerecorded: false,
                                active_src: 'https://player.vimeo.com/video/76979871',
                                starts_at: {
                                    iso_string: DateTime.now().toISO()
                                }
                            }}
                        />
                    </div>

                    <div className="mt-8">
                        <Link to="/">
                            <PrimaryButton
                                text="Go to home"
                            />
                        </Link>
                    </div>
                </div>
            </Authenticated>
        );
    }
}
